"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stepper = void 0;
const react_1 = __importDefault(require("react"));
const DefaultStepper_1 = require("./DefaultStepper");
const CustomHorizontalConnector_1 = __importDefault(require("./CustomHorizontalConnector"));
const Stepper = ({ steps, inlineLabel = false, activeStep = 0 }) => (react_1.default.createElement(DefaultStepper_1.Stepper, { activeStep: activeStep, alternativeLabel: !inlineLabel, connector: inlineLabel ? undefined : react_1.default.createElement(CustomHorizontalConnector_1.default, null) }, steps.map((step) => (react_1.default.createElement(DefaultStepper_1.Step, { key: step.key },
    react_1.default.createElement(DefaultStepper_1.StepLabel, { optional: step.optional ?
            react_1.default.createElement("div", { style: inlineLabel ? { fontSize: 12, marginLeft: 6 } : { fontSize: 12, marginLeft: -6 } }, "Optional") : undefined }, step.label))))));
exports.Stepper = Stepper;
//# sourceMappingURL=Stepper.js.map